import { MouseEventHandler, ReactNode } from 'react';

import {
  Button,
  SxProps,
  Theme,
  Typography,
  TypographyProps,
} from '@mui/material';

import StlTooltip from '../StlTooltip';
import { classNames } from '../utils';

import styles from './StlButton.module.css';

interface StlButtonProps {
  handleClick: MouseEventHandler<HTMLButtonElement>;
  width?: number | string;
  value?: string;
  isActive?: boolean;
  icon?: ReactNode;
  bold?: boolean;
  variant?: 'outlined' | 'contained' | 'text';
  color?: 'primary' | 'error' | 'errorStl' | any;
  gray?: boolean;
  brown?: boolean;
  sx?: SxProps<Theme>;
  tooltip?: ReactNode;
  classes?: string[];
  typographyVariant?: TypographyProps['variant'];
}

export function StlButton({
  value,
  isActive = true,
  handleClick,
  icon,
  width = '100%',
  bold = false,
  variant = 'contained',
  color = 'primary',
  gray = false,
  brown = false,
  sx = {},
  tooltip = false,
  classes = [],
  typographyVariant = 'body2',
}: StlButtonProps) {
  const button = (
    <Button
      color={color}
      variant={variant}
      startIcon={icon}
      onClick={handleClick}
      disabled={!isActive}
      className={classNames(
        styles.custom_button,
        gray && styles.gray_variant,
        brown && styles.brown_variant,
        ...classes,
      )}
      sx={{
        width,
        minWidth: typeof width === 'number' && width,
        ...sx,
      }}
    >
      <Typography
        className={classNames(bold && styles.bold)}
        variant={typographyVariant}
      >
        {value}
      </Typography>
    </Button>
  );
  // If a tooltip is provided, wrap with a span so it works when disabled.
  // button width must be absolute (no %)
  if (tooltip)
    return (
      <StlTooltip title={tooltip} placement="top">
        <span className={styles.wrapper}>{button}</span>
      </StlTooltip>
    );
  else return button;
}
